import { createRouter, createWebHistory } from 'vue-router'
import HomeView from './views/Home.vue'
import RecipeDetail from './views/RecipeDetail.vue'
import AboutView from './views/About.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomeView
  },
  {
    path: '/recipe/:id',
    name: 'RecipeDetail',
    component: RecipeDetail,
    props: true
  },
  {
    path: '/about',
    name: 'About',
    component: AboutView
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
